'use client';

import { addItemToCart } from '@/services/cart';
import useCart from '@/store/cart.store';
import useCheckout from '@/store/checkout.store';
import { getCookies, setCookie } from 'cookies-next';
import { useLocale, useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { toast } from '@/utils/toast';
// import { checkStockAvailability } from '@/utils/global';
// import useGlobalStore from '@/store/global.store';
import { SHIPPING_INFO_MODALS_NAMES } from '@/constants';
import { usePathname } from '@/i18n/navigation';
import useShippingInfoStore from '@/store/shipping-info.store';
import {
  event_add_to_cart,
  event_begin_checkout,
  event_buy_now,
} from '@/utils/gtm';
import { getItemId } from '@/utils/gtm/item-lists';
import { signIn } from 'next-auth/react';

const BuyNow = ({ product, qty = 1, fromPdp }) => {
  const t = useTranslations('product');
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const [loading, setLoading] = useState(false);

  // const { defaultSourceIds } = useGlobalStore();

  const {
    shippingMethod,
    shippingAddress,
    setIsOpenShippingInfoModal,
    setActiveStep,
  } = useShippingInfoStore();

  const cart = useCart((store) => store);
  const clearCheckout = useCheckout((state) => state.clearCheckout);

  // const is_stock = checkStockAvailability(
  //   product?.stock_innova || {},
  //   defaultSourceIds
  // );

  const is_stock = product?.stock?.is_in_stock && product?.stock?.qty > 0;

  // Checkout starts here too, so the whole cart is reported, not just this
  // product — /checkout renders every line.
  const startCheckout = (cartLines) =>
    event_begin_checkout({
      cartLines,
      cart: cart?.cart,
      coupon: cart?.cart?.coupon_code,
      locale,
    });

  const handleAddToCartFast = async () => {
    setLoading(true);
    const { quote, mage } = getCookies();

    // check if the product is in the cart to ignore adding again
    const singleProduct = cart.cartItems?.find(
      (item) => getItemId(item) === getItemId(product)
    );

    if (singleProduct) {
      if (mage) {
        if (
          shippingMethod === SHIPPING_INFO_MODALS_NAMES.HOME_DELIVERY &&
          !shippingAddress?.id
        ) {
          setIsOpenShippingInfoModal(true);
          setActiveStep(SHIPPING_INFO_MODALS_NAMES.DELIVERY_ADDRESS);
          return;
        } else if (
          shippingMethod === SHIPPING_INFO_MODALS_NAMES.STORE_PICKUP &&
          !shippingAddress?.id
        ) {
          setIsOpenShippingInfoModal(true);
          setActiveStep(SHIPPING_INFO_MODALS_NAMES.CHOOSE_BRANCH);
          return;
        } else if (!shippingMethod) {
          setIsOpenShippingInfoModal(true);
          setActiveStep(SHIPPING_INFO_MODALS_NAMES.SHIPPING_METHOD);
          return;
        } else {
          startCheckout(cart.cartItems);
          router.push('/checkout');
        }
      } else {
        startCheckout(cart.cartItems);
        signIn(undefined, { callbackUrl: `/${pathname}` });
      }
      setLoading(false);
      return;
    }

    const res = await addItemToCart({ sku: product?.sku, qty, quote, mage });
    let productFeesFromCart = [];
    if (res?.status === 200) {
      if (quote !== res?.data?.quoteId) {
        cart.resetCart();
        clearCheckout();
        setCookie('quote', res?.data?.quoteId);
      }

      cart?.addItem({
        ...product,
        ...res?.data?.data,
        qty,
        qty: res?.data?.data?.qty,
        productFeesFromCart,
      });

      // toast.success(t(res?.data?.message || 'Item Added To Cart succssfully'));

      // Spec: Buy Now is an add followed by a checkout start. `addItem` merges
      // by `item_id`, so the store read back here has each line once.
      event_add_to_cart({ product, quantity: qty, locale });
      startCheckout(useCart.getState().cartItems);
      event_buy_now({ product });

      if (mage) {
        router.push('/checkout');
      } else {
        router.push('/login');
      }

      setLoading(false);
    } else {
      toast.error(
        t(res?.error?.error?.message?.replaceAll('.', '') || 'ErrorAddToCart')
      );
      setLoading(false);
    }
  };

  const btnStyle = fromPdp
    ? 'bg-primary  flex items-center justify-center gap-1 w-[70%] cursor-pointer  rounded-[10px] px-[14px] py-[8px] text-[14px] font-bold text-white disabled:cursor-not-allowed disabled:opacity-40'
    : 'bg-primary disabled:bg-primary/50 hover:bg-primary/90 flex items-center justify-center gap-2 rounded-[12px] border px-3 py-3.5 font-medium text-white duration-300 hover:scale-102 disabled:border-0 disabled:text-white';

  return (
    <>
      <button
        onClick={handleAddToCartFast}
        disabled={loading || !is_stock}
        className={btnStyle}
      >
        {loading && (
          <span className='size-4 animate-spin rounded-full border-t border-r border-white py-1 max-lg:size-2' />
        )}
        {t('Buy Now')}
      </button>
    </>
  );
};

export default BuyNow;
